import { getUserRoles } from './authRoles';

const ROLE_PRIORITY = [
  'hke_admin',
  'consultant_admin',
  'consultant_advisor',
  'network_admin',
  'network_manager',
  'network_viewer',
  'network_user',
  'network_member',
  'organization_admin',
  'org_master',
  'org_admin',
  'org_user',
  'organization_user',
];

const ROLE_LABELS = {
  hke_admin: 'HKE Admin',
  consultant_admin: 'Consultant Admin',
  consultant_advisor: 'Consultant Advisor',
  network_admin: 'Network Admin',
  network_manager: 'Network Admin',
  network_viewer: 'Network Viewer',
  network_user: 'Network Viewer',
  network_member: 'Network Viewer',
  organization_admin: 'School Admin',
  org_master: 'School Admin',
  org_admin: 'School Admin',
  org_user: 'School User',
  organization_user: 'School User',
};

const titleizeRole = (role) =>
  String(role)
    .toLowerCase()
    .replaceAll('_', ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());

export const getDisplayRoleLabel = (role) => {
  const normalizedRole = String(role || '').toLowerCase().trim();
  if (!normalizedRole) return 'User';
  return ROLE_LABELS[normalizedRole] || titleizeRole(normalizedRole);
};

export const getDisplayRole = (user) => {
  if (!user) return null;

  const roles = (getUserRoles(user) || []).map(r => String(r).toLowerCase());

  // pick highest priority role
  const matched = ROLE_PRIORITY.find(role => roles.includes(role));

  if (matched) return getDisplayRoleLabel(matched);

  const firstRole = roles[0];
  if (firstRole) return getDisplayRoleLabel(firstRole);

  // fallback to legacy role if no RBAC match
  if (user.role) {
    return getDisplayRoleLabel(user.role);
  }

  return 'User';
};
